"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestAudioModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_react_1 = require("@streem/ui-react");
const react_1 = require("react");
const TestAudioModal = ({ onClose }) => {
    const theme = (0, ui_react_1.useTheme)();
    const audioTestSound = (0, react_1.useMemo)(() => {
        const ringtone = new Audio(`${window.location.origin}/streem_ringtone.mp3`);
        ringtone.loop = true;
        return ringtone;
    }, []);
    (0, react_1.useEffect)(() => {
        audioTestSound.play();
        return () => audioTestSound.pause();
    }, [audioTestSound]);
    return ((0, jsx_runtime_1.jsxs)(ui_react_1.Modal, Object.assign({ isOpen: true, onClose: onClose, mobile: true, closeDelayMS: 200, variant: "danger", cardProps: {
            decoratorPosition: undefined,
        }, styleOverride: {
            overlay: {
                paddingTop: '1rem',
                height: '100%',
                minHeight: '-webkit-fill-available',
            },
            content: {
                height: '100%',
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
            },
        } }, { children: [(0, jsx_runtime_1.jsx)(ui_react_1.Row, Object.assign({ mb: '2.5vh' }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.Header, Object.assign({ size: "large", bold: false }, { children: "Audio Test" })) })), (0, jsx_runtime_1.jsx)(ui_react_1.Row, Object.assign({ style: {
                    background: theme.colors.grey05,
                    margin: '0px auto 2.5vh',
                    justifyContent: 'center',
                    height: '135px',
                } }, { children: (0, jsx_runtime_1.jsxs)(ui_react_1.Flex, Object.assign({ "data-testd": "playing-audio-icon", flexDirection: "column", alignItems: "center", justifyContent: "space-evenly" }, { children: [(0, jsx_runtime_1.jsx)(ui_react_1.SpeakerIcon, { size: '57px' }), (0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ as: "h4", style: {
                                fontSize: '18px',
                            }, headingFontFamily: true }, { children: "Playing Audio..." }))] })) })), (0, jsx_runtime_1.jsx)(ui_react_1.Row, Object.assign({ mb: '2.5vh' }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ as: "h4", style: {
                        fontSize: '18px',
                    }, headingFontFamily: true }, { children: "Can't hear it? Try these steps." })) })), (0, jsx_runtime_1.jsx)(ui_react_1.Row, Object.assign({ "data-testid": "audio-fix-steps", pl: "20px", mb: '5vh' }, { children: (0, jsx_runtime_1.jsxs)("ul", Object.assign({ style: { listStyleType: 'disc' } }, { children: [(0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ as: "li", style: { marginBottom: '2.5vh' } }, { children: "Make sure your phone is not in silent mode." })), (0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ as: "li", style: { marginBottom: '2.5vh' } }, { children: "If you're using headphones, disconnect or turn them off to use your phone's speaker instead." }))] })) })), (0, jsx_runtime_1.jsx)(ui_react_1.Row, Object.assign({ justifyContent: "flex-end" }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.Button, Object.assign({ "data-testid": "audio-test-close-button", variant: "secondary", mobile: true, onClick: onClose }, { children: "Close" })) }))] })));
};
exports.TestAudioModal = TestAudioModal;
//# sourceMappingURL=test_audio_modal.js.map